const CRAFTING_COST_ORDER = ['gold', 'wood'];

export const sortCraftingCost = (array = []) => {
  const priority = (item) => {
    const key = (item?.pair ?? item?.fullName ?? item?.name ?? item?.asset ?? '').toLowerCase();
    const index = CRAFTING_COST_ORDER.indexOf(key);
    return index === -1 ? CRAFTING_COST_ORDER.length : index;
  };

  return [...array].sort((a, b) => priority(a) - priority(b));
};

export const createArrayOfArrays = (array, numElements = 2) => {
  return array.reduce((acc, _, index) => {
    const startIndex = index * numElements;
    const endIndex = startIndex + numElements;
    acc.push(array.slice(startIndex, endIndex));
    return acc;
  }, []);
};
